export const ErrorMessage = (error) => {
  switch (error.response.status) {
    /*case 401:
            return 'Error en la contraseña';*/
    default:
      return error.response?.data?.detail
        ? error.response.data.detail
        : 'Intenta más tarde';
  }
};
